module.exports = __webpack_public_path__ + "img/blog-4-1.d45351a6.webp";